import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/MetaDataApi/" );
const internalInstance = new HttpService( "umbraco/api/MetadataApi" );

/* eslint-disable arrow-body-style */

/**
 * Load meta data configuration
 *
 * @param {Number} objectId The ID of the object we are loading meta data for
 * @param {GUID} containerId The container ID to load (NULL to load all containers)
 * @param {Number} recordTypeId The record type ID to use.
 * @param {GUID} pkValue The primary key to load existing meta data values
 * @param {Boolean} blankOnly The true and we are loading existing meta dat avalues, only values
 *                              that have not been populated will be returned
 */
export const metaDataConfig = ( objectId, containerId, recordTypeId, pkValue, blankOnly ) => {
  // pkValue is a string so passing undefined or null will pass the word "undefined" or "null",
  // this breaks the site as the controller does not understand this, so we make sure undefine
  // or null are converted to a blank string
  const convertedPkValue = pkValue || "";
  return instance.get( `MetaDataConfig?objectId=${objectId}&containerId=${containerId}&recordTypeId=${recordTypeId}&pkValue=${convertedPkValue}&blankOnly=${blankOnly}` );
};

/**
 * Loads metadata from the current user
 *
 * @param {GUID} containerId The container ID to load (NULL to load all containers)
 * @param {Boolean} noLookUpValues if set to true no look up values.</param>
 * @param {String} fieldIds The field IDs (a semi colon delimited string of values).</param>
 * @param {String} fieldNames The field names (a semi colon delimited string of values).</param>
 * @param {String} labels The labels (a semi colon delimited string of values).</param>
 * @param {Boolean} noUnpopulated if set to true no unpopulated.</param>
 */
export const loadMetadata = (
  containerId = null,
  noLookUpValues = null,
  fieldIds = "",
  fieldNames = "",
  labels = "",
  noUnpopulated = null,
) => internalInstance.get( `LoadMetadata?containerId=${containerId}
  &noLookUpValues=${noLookUpValues}
  &fieldsIds=${fieldIds}
  &fieldNames=${fieldNames}
  &labels=${labels}
  &noUnpopulated=${noUnpopulated}` );

/**
 *  Loads the order header metadata
 * @param orderId {GUID} The order header ID to load metadata from
 * @param {GUID} containerId An optional container ID to load (NULL to load all containers)
 * @param {Boolean} noLookUpValues if set to true no look up values.</param>
 * @param {String} fieldIds The field IDs (a semi colon delimited string of values).</param>
 * @param {String} fieldNames The field names (a semi colon delimited string of values).</param>
 * @param {String} labels The labels (a semi colon delimited string of values).</param>
 * @param {Boolean} noUnpopulated if set to true no unpopulated.</param>
 * @returns {Array<Object>} metadata  ex: [{ fieldName, value }] the data to save
 */
export const loadOrderHeaderMetadata = (
  orderId,
  containerId,
  fieldIds = "",
  fieldNames = "",
  labels = "",
  noLookUpValues = null,
  noUnpopulated = null,
) => {
  const payload = {
    orderId,
    containerId,
    noLookUpValues,
    fieldIds,
    fieldNames,
    labels,
    noUnpopulated,
  };

  return internalInstance.post( "LoadOrderHeaderMetadata", payload );
};

/**
 * Save the order header metadata
 *
 *  @param {GUID} orderHeaderId The ID of the order to save against
 *  @param {Array<Object>} metadata  ex: [{ fieldName, value }] the data to save
 */
export const saveOrderHeaderMetadata = ( orderHeaderId, metadata ) => {
  const payload = { orderHeaderId, metadata };
  return internalInstance.post( "SaveOrderHeaderMetadata", payload );
};

export const saveUserPreferencesMetaData = ( metadata ) => instance.post( "SaveUserPreferencesMetaData", metadata );

export const saveRegistrationMetaData = ( metadata ) => instance.post( "SaveRegistrationMetaData", metadata );

export const loadUserPreferencesMetaData = () => instance.get( "LoadUserPreferencesMetaData" );
